import React from 'react';

// Inline SVG instead of the DS Icon component: Icon renders via a
// shadow-DOM asset that's only inlined for icons present in the initial
// server-rendered HTML. SearchBarTooltip mounts client-side only (after
// the cookie/experiment check resolves), so the icon would otherwise pop
// in late while it fetches.
const CloseIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 32 32"
		aria-hidden="true"
		focusable="false"
	>
		<path
			fill="currentColor"
			d="M17.279 16l10.457-10.46c0.352-0.352 0.352-0.924 0-1.276s-0.924-0.352-1.276 0l-10.471 10.46-10.443-10.46c-0.355-0.345-0.921-0.345-1.276 0-0.173 0.167-0.27 0.398-0.27 0.638s0.098 0.471 0.27 0.638l10.457 10.46-10.457 10.46c-0.173 0.167-0.27 0.398-0.27 0.638s0.098 0.471 0.27 0.638c0.167 0.173 0.398 0.269 0.638 0.264 0.239 0 0.469-0.095 0.638-0.264l10.443-10.46 10.457 10.46c0.166 0.173 0.398 0.269 0.638 0.264 0.239 0 0.469-0.095 0.638-0.264 0.345-0.355 0.345-0.921 0-1.276l-10.443-10.46z"
		/>
	</svg>
);

export default CloseIcon;
